/* MAUD colour thumbnails next to the colour arrows (T, Oct 6 2026).
   The theme's colour swatches stay hidden inside the variant picker (it needs them there);
   this draws a row of the same colour images right under ‹ COLOUR › and drives the real
   radios, so shoppers can step with the arrows or tap a colour. Hover and the selected
   colour glow red. Works on product pages and in the quick-view pop-up. */
(function () {
  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }

  function build(nav) {
    if (nav._mdsw) return;
    var pm = nav.closest('product-media[data-dtg]');
    if (!pm) return;
    var form = document.getElementById(pm.getAttribute('form-id'));
    if (!form) return;
    var radios = [].slice.call(document.querySelectorAll('.variant-swatch-list input[type="radio"][form="' + cssEsc(form.getAttribute('id'))   /* not form.id: the form has an input named "id", which shadows it */ + '"]'));
    if (radios.length < 2) return;
    nav._mdsw = true;

    var row = document.createElement('div');
    row.className = 'mdsw';
    row.setAttribute('role', 'radiogroup');
    row.setAttribute('aria-label', 'Colour');
    radios.forEach(function (r) {
      var lab = r.parentNode.querySelector('label'), img = lab && lab.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mdsw__item';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', r.value);
      b.title = r.value;
      b.dataset.v = r.value;
      if (img) {
        var i = document.createElement('img');
        i.alt = '';
        i.decoding = 'async';
        i.src = img.currentSrc || img.getAttribute('src') || '';
        if (img.getAttribute('srcset')) { i.srcset = img.getAttribute('srcset'); i.sizes = '64px'; }
        b.appendChild(i);
      } else {
        b.textContent = r.value;
      }
      b.addEventListener('click', function () {
        if (r.checked) return;
        pm.dispatchEvent(new CustomEvent('dtg:keepview'));   /* tapping a colour keeps the current view; only the arrows open both sides */
        r.click();
      });
      row.appendChild(b);
    });
    nav.parentNode.insertBefore(row, nav.nextSibling);

    function sync() {
      var cur = radios.filter(function (x) { return x.checked; })[0];
      row.querySelectorAll('.mdsw__item').forEach(function (b) {
        var on = !!cur && b.dataset.v === cur.value;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    /* the front-image swap for swatches can land after we copied — refresh the thumbs once */
    setTimeout(function () {
      radios.forEach(function (r, k) {
        var img = r.parentNode.querySelector('label img'), t = row.children[k] && row.children[k].querySelector('img');
        if (img && t) { if (img.getAttribute('srcset')) t.srcset = img.getAttribute('srcset'); t.src = img.currentSrc || img.getAttribute('src') || t.src; }
      });
    }, 600);
    form.addEventListener('variant:changed', function () { setTimeout(sync, 0); });
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();
  }

  function scan() { document.querySelectorAll('.dtg-colornav').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var t = 0;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 60); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
